import React, { useEffect } from "react";
import {
  Container,
  Card,
  CardGroup,
  ListGroup,
  ListGroupItem,
} from "react-bootstrap";
import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

//  styles
import "./Services.scss";

//	cards
import cards from "../../../data/cardElements";

const Services = () => {
  gsap.registerPlugin(ScrollTrigger);
  const sectionRefs = React.useRef([]);
  sectionRefs.current = [];

  const calcDelay = (index) => {
    if (index === 0) {
      return index;
    }
    return index - index * 0.5;
  };

  useEffect(() => {
    sectionRefs.current.forEach((el, index) => {
      gsap.fromTo(
        el,
        { autoAlpha: 0, y: 50 },
        {
          duration: 1,
          autoAlpha: 1,
          delay: calcDelay(index),
          y: 0,
          ease: "power4.out",
          scrollTrigger: {
            id: `servicos`,
            trigger: el,
            start: "top center+=100",
          },
        }
      );
    });
  }, []);

  const addToRefs = (el) => {
    if (el && !sectionRefs.current.includes(el)) {
      sectionRefs.current.push(el);
    }
  };

  return (
    <div id="servicos" className="block">
      <Container className="align-self-center">
        <CardGroup>
          {cards.map((card, i) => {
            return (
              <Card
                key={card.id}
                ref={addToRefs}
                className="text-center px-3 mx-3 bg-light"
              >
                <Card.Img
                  variant="top"
                  src={card.src}
                  alt={`${card.title} Icon`}
                  className="mt-5 mb-4 img-fluid mini-logo align-self-center"
                />
                <Card.Body>
                  <Card.Title>{card.title}</Card.Title>
                  <br />
                  <Card.Text>{card.text}</Card.Text>
                  <p className="list-title">Languages:</p>
                  <p>{card.languages}</p>
                  <p className="list-title">Tools:</p>
                  <ListGroup variant="flush">
                    {card.tools.map((tool) => {
                      return (
                        <ListGroupItem key={tool.id} className="link bg-light">
                          {tool.name}
                        </ListGroupItem>
                      );
                    })}
                  </ListGroup>
                </Card.Body>
              </Card>
            );
          })}
        </CardGroup>
      </Container>
    </div>
  );
};

export default Services;
